<x-y-graph [chartTitle]="currentTitle" [showKey]="true" [chartId]="'redactionChart'" 
    [graphPair]="graphPair">
    <div class="graph-date-controls" chart-controls>
        <div class="custom-radio-group">
            <label class="custom-radio-button-container" for="video-option">Video Redaction
                <input type="radio" value="video" [(ngModel)]="dataShown" (change)="setDataShown($event.target.value)" name="redaction-toggle" id="video-option">
                <span class="custom-radio-button"></span>
            </label>
            <label class="custom-radio-button-container" for="audio-option">Audio Redaction
                <input type="radio" value="audio" [(ngModel)]="dataShown" (change)="setDataShown($event.target.value)" name="redaction-toggle" id="audio-option">
                <span class="custom-radio-button"></span>
            </label>
        </div>
        <date-selector (selectedDateChange)="onDateChange($event)" [selectedDate]="selectedDate" [startDate]="earliestSelectionDate" [endDate]="latestSelectionDate"/>
    </div>
</x-y-graph>